module.exports = __webpack_public_path__ + "img/stock3.63c9764c.png";